import { render } from "./Product Expiration.vue?vue&type=template&id=1fcaf232"
import script from "./Product Expiration.vue?vue&type=script&lang=js"
export * from "./Product Expiration.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__